import React from 'react';
import propTypes from 'prop-types';
import FlipMove from 'react-flip-move';
import { getMessage } from 'util/locale';

import TrialPlacementsQuickView from './TrialPlacementsQuickView';

const baseString = 'vra-trial-placements';

const TrialPlacements = ({
  onSelectTrialPlacements,
  selectedTrialPlacementsId,
  trialPlacements,
  fieldBoundary
}) => {
  let trialPlacementOptionList = [];
  if (trialPlacements && trialPlacements.length) {
    if(!selectedTrialPlacementsId) {
      onSelectTrialPlacements(trialPlacements[0].id);
    }
    trialPlacementOptionList = trialPlacements
    .map((placementsData, index) => {
      let headerText = getMessage('text__trial-placements--option-name', { num: index + 1 });

      return (
        <li
          key={placementsData.id}
        >
          <TrialPlacementsQuickView
            fieldBoundary={fieldBoundary}
            headerText={headerText}
            onSelectTrialPlacements={onSelectTrialPlacements}
            placementsData={placementsData}
            selectedTrialPlacementsId={selectedTrialPlacementsId}
          />
        </li>
      );
    });
  }
  return (
    <section
      className={`${baseString}-side-panel`}
    >
      {
        trialPlacementOptionList && trialPlacementOptionList.length > 0
          ? <div>
            <section
              className={`${baseString}-options-list__wrapper`}
              data-test-id={`${baseString}-options-list`}
            >
              <FlipMove
                enterAnimation={null}
                leaveAnimation={null}
                typeName='ul'
              >
                {trialPlacementOptionList}
              </FlipMove>
            </section>
          </div>
          : <div className="loading-message">{getMessage('text__trial-placements--loading')}</div>
      }
    </section>
  );
};

TrialPlacements.propTypes = {
  fieldBoundary: propTypes.any,
  onSelectTrialPlacements: propTypes.func.isRequired,
  selectedTrialPlacementsId: propTypes.string.isRequired,
  trialPlacements: propTypes.array.isRequired
};

export default TrialPlacements;
